import { Box } from '@mui/material'

import { useResourceData } from '@/features/resource/contexts/ResourceDataContext'
import { CloudResourceTabs } from '@/features/resource/pages/components/CloudResourceTabs'
import { LocalResourceTabs } from '@/features/resource/pages/components/LocalResourceTabs'

type ResourceTabsProps = Readonly<{
  activeTab: string
}>

export function ResourceTabs({ activeTab }: ResourceTabsProps) {
  const { resource } = useResourceData()

  if (!resource) {
    return null
  }

  return (
    <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
      {resource.controlMode === 'LOCAL' ? (
        <LocalResourceTabs activeTab={activeTab} />
      ) : (
        <CloudResourceTabs activeTab={activeTab} />
      )}
    </Box>
  )
}
